import { render, staticRenderFns } from "./TrashUndo.vue?vue&type=template&id=ed7eb5b4&"
import script from "./TrashUndo.vue?vue&type=script&lang=js&"
export * from "./TrashUndo.vue?vue&type=script&lang=js&"
import style0 from "./TrashUndo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports